export const dropShadow = {
  boxShadow: '0 2px 6px 0 rgba(195,195,195,0.50)',
};
